"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_SPAN_CATEGORY_KEY = 'base';
exports.TEXT_SPAN_PARENT_COMPONENT_KEY = 'text';
exports.TEXT_SPAN_COMPONENT_KEY = 'textSpan';